/* =====================================================================
   NŒUD-NŒUD ATELIER — layout "Maison" (custom CARRON, hors Impact vanilla)
   Comportement du panneau de personnalisation guide :
   - grille couleur (vraies photos de noeuds) -> pilote l'option couleur native
   - bascules format / taille (vignettes photo) -> pilotent les options natives
   - rangees depliables (un seul ouvert a la fois)
   - champ "un mot" (lettres, max 10) -> propriete de ligne (+ supplement optionnel)
   - prix live (total + 3x), libelle du bouton, date de livraison
   - apercu live : photo + masque par taille/format, teinte des noeuds (--nn-bow-color)

   Couleur + numero = propriete de ligne "A peindre" pour l'atelier.
   Les hexes de la palette sont des aperçus (a remplacer par les vrais emaux).
   ===================================================================== */
(function () {
  'use strict';

  function readJSON(sel) {
    var el = document.querySelector(sel);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  var CFG = readJSON('[data-nn-config]');
  if (!CFG) return;
  var MEDIA = readJSON('[data-nn-media]') || {};
  var I18N = CFG.i18n || {};
  var PAL = {};
  (CFG.palette || []).forEach(function (p) { PAL[p.n] = p; });

  /* ---- etat soucoupe (5e etape) ---- */
  var SAU = CFG.saucer || { enabled: false };
  var saucerOn = false;
  var saucerColorN = null; /* null = herite la couleur du mug */
  var curSaucerSize = null, curSaucerVid = null, curSaucerCents = 0;
  function saucerEnabled() { return !!(SAU && SAU.enabled && SAU.variants); }
  function effSaucerColorN() { return saucerColorN || currentColorN; }
  function saucerCents() { return (saucerOn && saucerEnabled()) ? (curSaucerCents || 0) : 0; }

  /* ---- etat ---- */
  var currentCents = CFG.initialPriceCents || 0;
  var currentColorN = CFG.initialColorN || null;
  var wordValue = '';
  function wordActive() { return wordValue.trim().length > 0; }
  function effFeeCents() { return (wordActive() && (CFG.wordFeeCents || 0) > 0) ? CFG.wordFeeCents : 0; }

  /* ---- formatage prix (EUR, virgule decimale) ---- */
  function fmtEuro(cents) { return '€' + (cents / 100).toFixed(2).replace('.', ','); }

  /* ---- radios natifs (variant-picker masque) ---- */
  function clickRadio(pos, valId) {
    if (pos == null || valId == null || valId === '') return false;
    var r = document.querySelector('variant-picker input[type="radio"][data-option-position="' + pos + '"][value="' + valId + '"]');
    if (r) { if (!r.checked) r.click(); return true; }
    return false;
  }

  /* ---- proprietes de ligne (portees au panier, re-appliquees apres rerender) ---- */
  var painterInput = null, wordInput = null;
  function currentForm() {
    return document.getElementById(CFG.formId) || document.querySelector('form[action*="/cart/add"]');
  }
  function ensureProps() {
    var form = currentForm();
    if (!form) return null;
    painterInput = form.querySelector('input[data-nn-prop="painter"]');
    if (!painterInput) {
      painterInput = document.createElement('input');
      painterInput.type = 'hidden';
      painterInput.setAttribute('data-nn-prop', 'painter');
      form.appendChild(painterInput);
    }
    wordInput = form.querySelector('input[data-nn-prop="word"]');
    if (!wordInput) {
      wordInput = document.createElement('input');
      wordInput.type = 'hidden';
      wordInput.setAttribute('data-nn-prop', 'word');
      form.appendChild(wordInput);
    }
    return form;
  }
  function applyProps() {
    if (!ensureProps()) return;
    var p = PAL[currentColorN];
    if (p) {
      painterInput.name = 'properties[' + (CFG.propertyName || 'À peindre') + ']';
      painterInput.value = 'n°' + currentColorN + ' - ' + p.name;
      painterInput.disabled = false;
    }
    if (wordActive()) {
      wordInput.name = 'properties[' + (CFG.wordProperty || 'Mot') + ']';
      wordInput.value = wordValue.trim();
      wordInput.disabled = false;
    } else {
      wordInput.disabled = true;
      wordInput.value = '';
    }
  }

  /* ---- prix / 3x / bouton ---- */
  function renderPrice() {
    var total = (currentCents || 0) + effFeeCents() + saucerCents();
    var now = $('[data-nn-price-now]');
    if (now) { var nv = fmtEuro(total); if (now.textContent !== nv) now.textContent = nv; }
    var cta = $('.nn-mais__cta button[type="submit"]');
    if (cta) {
      var base = cta.getAttribute('data-nn-cta-base');
      if (!base) { base = CFG.ctaBase || cta.textContent.replace(/\s*·\s*€.*$/, '').trim(); cta.setAttribute('data-nn-cta-base', base); }
      var want = base + ' · €' + Math.round(total / 100);
      if (cta.textContent.trim() !== want) cta.textContent = want;
    }
  }

  /* ---- couleur ---- */
  function bowUrlFor(n) {
    var img = document.querySelector('.nn-mais__swatch[data-nn-color="' + n + '"] img');
    return img ? img.src : '';
  }
  function applyColor(n) {
    var p = PAL[n];
    if (!p) return;
    currentColorN = n;
    document.documentElement.style.setProperty('--nn-bow-color', p.hex);
    var url = bowUrlFor(n);
    if (url) {
      $all('[data-nn-chip-bow]').forEach(function (im) { im.src = url; });
      $all('[data-nn-row-bow]').forEach(function (im) { im.src = url; });
    }
    var short = 'N°' + (n < 10 ? '0' : '') + n + ' · ' + p.name;
    $all('[data-nn-recap-short]').forEach(function (el) { el.textContent = short; });
    var cs = $('[data-nn-summary="color"]');
    if (cs) cs.textContent = (I18N.colorPrefix || 'no.') + n + ' · ' + p.name;
    $all('.nn-mais__swatch').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-nn-color') === String(n) ? 'true' : 'false');
    });
    applyProps();
    if (saucerEnabled() && !saucerColorN) renderSaucer();
  }

  /* ---- apercu live : photo + masque par format/taille ---- */
  function fmtKey(h) { return /tumbler|no handle|sans anse|sans/i.test(String(h)) ? 'tumbler' : 'mug'; }
  function sizeKey(d) { var m = String(d).match(/(^|[^A-Za-z])([SML])([^A-Za-z]|$)/); return m ? m[2] : 'M'; }
  function applyMedia(format, size) {
    var e = (MEDIA[format] && MEDIA[format][size]) || (MEDIA.mug && MEDIA.mug[size]);
    if (!e) return;
    var img = $('[data-nn-photo]');
    var tint = $('[data-nn-tint]');
    if (!img) return;
    function swap() {
      if (e.photo) img.setAttribute('src', e.photo);
      if (tint && e.mask) tint.style.setProperty('--nn-mask-url', 'url("' + e.mask + '")');
    }
    if (img.getAttribute('src') === e.photo) { swap(); return; }
    var pre = new Image();
    pre.onload = swap;
    pre.onerror = swap;
    pre.src = e.photo;
  }

  /* photo d'une piece (format + taille), pour les vignettes taille + les mini-resumes */
  function getPhoto(format, size) {
    var e = (MEDIA[format] && MEDIA[format][size]) || (MEDIA.mug && MEDIA.mug[size]);
    return e ? e.photo : null;
  }
  /* les images de "taille" suivent le format (mug / tumbler) + mini-photos des resumes replies */
  function updateOptionThumbs(format, size) {
    var fimg = $('[data-nn-fmt-img]');
    var fp = getPhoto(format, 'M');
    if (fimg && fp) fimg.src = fp;
    var simg = $('[data-nn-size-img]');
    var sp = getPhoto(format, size);
    if (simg && sp) simg.src = sp;
    $all('[data-nn-size-thumb]').forEach(function (im) {
      var p = getPhoto(format, im.getAttribute('data-nn-size'));
      if (p) im.src = p;
    });
  }

  /* ---- selecteur couleur (grille de vraies photos) ---- */
  function wireSwatches() {
    $all('.nn-mais__swatch').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var n = parseInt(btn.getAttribute('data-nn-color'), 10);
        var vid = btn.getAttribute('data-nn-val-id');
        if (vid) clickRadio(CFG.colorPosition, vid);
        applyColor(n);
      });
    });
  }

  /* ---- bascules format / taille ---- */
  function wireToggles() {
    $all('.nn-mais__opt').forEach(function (btn) {
      btn.addEventListener('click', function () {
        clickRadio(btn.getAttribute('data-nn-opt-pos'), btn.getAttribute('data-nn-val-id'));
        var group = btn.closest('.nn-mais__toggle');
        if (group) $all('.nn-mais__opt', group).forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        var row = btn.closest('.nn-mais__row');
        var which = row ? row.getAttribute('data-nn-row') : null;
        var sum = btn.getAttribute('data-nn-opt-summary');
        if (which && sum) { var t = $('[data-nn-summary="' + which + '"]'); if (t) t.textContent = sum; }
      });
    });
  }

  /* ---- rangees depliables (un seul ouvert) ---- */
  function wireAccordion() {
    $all('[data-nn-rowhead]').forEach(function (head) {
      head.addEventListener('click', function () {
        var row = head.closest('.nn-mais__row');
        if (!row) return;
        var isOpen = row.classList.contains('is-open');
        $all('.nn-mais__row').forEach(function (r) {
          r.classList.remove('is-open');
          var h = $('[data-nn-rowhead]', r);
          if (h) h.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) { row.classList.add('is-open'); head.setAttribute('aria-expanded', 'true'); }
      });
    });
  }

  /* ---- champ "un mot" ---- */
  function wireWord() {
    var inp = $('[data-nn-word]');
    if (!inp) return;
    var cnt = $('[data-nn-word-count]');
    var sum = $('[data-nn-summary="word"]');
    inp.addEventListener('input', function () {
      var v = inp.value;
      try { v = v.replace(/[^\p{L}]/gu, ''); } catch (e) { v = v.replace(/[^A-Za-zÀ-ÿ]/g, ''); }
      v = v.slice(0, 10);
      if (v !== inp.value) inp.value = v;
      wordValue = v;
      if (cnt) cnt.textContent = String(v.length);
      if (sum) sum.textContent = wordActive()
        ? ('« ' + v + ' »' + ((CFG.wordFeeCents || 0) > 0 ? (I18N.feeSuffix || '') : ''))
        : (I18N.none || 'None');
      applyProps();
      renderPrice();
    });
  }

  /* ---- lightbox vignettes (agrandissement) ---- */
  var lb = null, lbImg = null, lbSaucer = null, lbSauImg = null, lbSauTint = null, lbSauNote = null;
  function ensureLightbox() {
    if (lb) return;
    lb = document.createElement('div');
    lb.className = 'nn-lightbox';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lbImg = document.createElement('img');
    lbImg.className = 'nn-lightbox__img';
    lbImg.alt = '';
    lbSaucer = document.createElement('div');
    lbSaucer.className = 'nn-lightbox__saucer';
    lbSaucer.hidden = true;
    lbSauImg = document.createElement('img');
    lbSauImg.className = 'nn-lightbox__saucer-photo';
    lbSauImg.alt = '';
    lbSauTint = document.createElement('span');
    lbSauTint.className = 'nn-mais__saucer-tint';
    lbSauNote = document.createElement('p');
    lbSauNote.className = 'nn-mais__stage-note';
    lbSaucer.appendChild(lbSauImg);
    lbSaucer.appendChild(lbSauTint);
    lbSaucer.appendChild(lbSauNote);
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'nn-lightbox__close';
    close.setAttribute('aria-label', CFG.locale === 'fr' ? 'Fermer' : 'Close');
    close.innerHTML = '&times;';
    lb.appendChild(lbImg);
    lb.appendChild(lbSaucer);
    lb.appendChild(close);
    lb.addEventListener('click', hideLightbox);
    document.body.appendChild(lb);
  }
  function showLightbox(src, alt) {
    ensureLightbox();
    if (lbSaucer) lbSaucer.hidden = true;
    if (lbImg) lbImg.style.display = '';
    lbImg.src = src;
    lbImg.alt = alt || '';
    lb.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }
  function showSaucerZoom() {
    if (!saucerEnabled()) return;
    ensureLightbox();
    var m = (SAU.media && SAU.media[curSaucerSize || 'M']) || null;
    var ph = $('[data-nn-saucer-photo]');
    var src = (m && m.photo) || (ph && ph.src) || '';
    if (lbSauImg && src) lbSauImg.src = src;
    if (lbSauTint && m && m.mask) lbSauTint.style.setProperty('--nn-saucer-mask', "url('" + m.mask + "')");
    if (lbSauNote) lbSauNote.innerHTML = (SAU.i18n && SAU.i18n.disc) || '';
    if (lbImg) lbImg.style.display = 'none';
    if (lbSaucer) lbSaucer.hidden = false;
    lb.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }
  function hideLightbox() {
    if (lb) { lb.classList.remove('is-open'); document.documentElement.style.overflow = ''; }
  }
  function wireLightbox() {
    var triggers = $all('[data-nn-zoom]');
    if (!triggers.length) return;
    triggers.forEach(function (t) {
      t.addEventListener('click', function () {
        var im = t.querySelector('img');
        showLightbox(t.getAttribute('data-nn-zoom'), im ? im.alt : '');
      });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hideLightbox(); });
  }

  /* ---- soucoupe : resolution variante par taille + rendu ---- */
  function colorValue(n) {
    var p = PAL[n];
    return p ? ('n°' + n + ' - ' + p.name) : ('n°' + n);
  }
  function resolveSaucer(mugSize) {
    if (!saucerEnabled()) return;
    var sl = (SAU.sizeMap && SAU.sizeMap[mugSize]) || 'M';
    var v = SAU.variants[sl];
    if (!v) { for (var k in SAU.variants) { v = SAU.variants[k]; sl = k; break; } }
    if (!v) return;
    curSaucerSize = sl; curSaucerVid = v.id; curSaucerCents = v.cents || 0;
    var sEl = $('[data-nn-saucer-size]');
    if (sEl) sEl.textContent = v.title || sl;
    var m = SAU.media && SAU.media[sl];
    if (m) {
      var ph = $('[data-nn-saucer-photo]');
      if (ph && m.photo && ph.getAttribute('src') !== m.photo) ph.setAttribute('src', m.photo);
      var tint = $('[data-nn-saucer-tint]');
      if (tint && m.mask) tint.style.setProperty('--nn-saucer-mask', "url('" + m.mask + "')");
    }
  }
  function renderSaucerChips() {
    var n = effSaucerColorN();
    var p = PAL[n];
    if (!p) return;
    document.documentElement.style.setProperty('--nn-saucer-color', p.hex);
    var txt = $('[data-nn-saucer-colortxt]');
    if (txt) {
      if (saucerColorN) { txt.textContent = 'n°' + saucerColorN + ' · ' + p.name; }
      else { txt.textContent = (SAU.i18n && SAU.i18n.colorSame) || 'Knot painted in the mug colour'; }
    }
    $all('.nn-sc-swatch').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-nn-saucer-color') === String(n) ? 'true' : 'false');
    });
  }
  function renderSaucer() {
    if (!saucerEnabled()) return;
    var priceEl = $('[data-nn-saucer-price]');
    if (priceEl) priceEl.textContent = curSaucerCents ? ('+ €' + Math.round(curSaucerCents / 100)) : '';
    renderSaucerChips();
    var sum = $('[data-nn-summary="saucer"]');
    var wrap = $('[data-nn-saucer-thumbwrap]');
    var detail = $('[data-nn-saucer-detail]');
    if (saucerOn) {
      var n = effSaucerColorN(); var p = PAL[n];
      if (sum) sum.textContent = (curSaucerSize || '') + (curSaucerSize && p ? ' · ' : '') + (p ? p.name : '');
      if (wrap) wrap.hidden = false;
      if (detail) detail.hidden = false;
    } else {
      if (sum) sum.textContent = (SAU.i18n && SAU.i18n.none) || 'None';
      if (wrap) wrap.hidden = true;
      if (detail) detail.hidden = true;
    }
  }
  function wireSaucer() {
    if (!saucerEnabled()) return;
    var zoom = $('[data-nn-saucer-zoom]');
    if (zoom) zoom.addEventListener('click', function () { showSaucerZoom(); });
    var toggle = $('[data-nn-saucer-toggle]');
    if (toggle) toggle.addEventListener('change', function () {
      saucerOn = !!toggle.checked; renderSaucer(); renderPrice();
    });
    var change = $('[data-nn-saucer-change]');
    var sw = $('[data-nn-saucer-swatches]');
    if (change && sw) change.addEventListener('click', function () { sw.hidden = !sw.hidden; });
    $all('.nn-sc-swatch').forEach(function (b) {
      b.addEventListener('click', function () {
        saucerColorN = parseInt(b.getAttribute('data-nn-saucer-color'), 10);
        renderSaucer();
        if (sw) sw.hidden = true;
      });
    });
    var reset = $('[data-nn-saucer-reset]');
    if (reset) reset.addEventListener('click', function () {
      saucerColorN = null; renderSaucer();
      if (sw) sw.hidden = true;
    });
  }

  /* ---- panier : mug + (soucoupe) + (supplement mot) en une fois ---- */
  function wireAddon() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.getAttribute('id') !== CFG.formId) return; /* form.id est masque par l'input name="id" (variant) */
      var addWord = !!(CFG.addonVariantId && wordActive());
      var addSaucer = !!(saucerOn && saucerEnabled() && curSaucerVid);
      if (!addWord && !addSaucer) return; /* mug seul : flux Impact natif */
      e.preventDefault();
      e.stopImmediatePropagation();
      var vid = (new URLSearchParams(location.search)).get('variant') || CFG.initialVariantId;
      var qtyEl = document.getElementById(CFG.formId + '-quantity');
      var qty = qtyEl ? Math.max(1, parseInt(qtyEl.value || '1', 10)) : 1;
      var setToken = 'nn-' + (CFG.initialVariantId || '') + '-' + Date.now();
      var mainProps = {};
      mainProps[CFG.propertyName || 'À peindre'] = colorValue(currentColorN);
      if (wordActive()) mainProps[CFG.wordProperty || 'Mot'] = wordValue.trim();
      if (addSaucer || addWord) mainProps[SAU.setProperty || '_nn_set'] = setToken;
      var items = [{ id: vid, quantity: qty, properties: mainProps }];
      if (addSaucer) {
        var sProps = {};
        sProps[SAU.propertyName || 'À peindre'] = colorValue(effSaucerColorN());
        sProps[SAU.setProperty || '_nn_set'] = setToken;
        items.push({ id: curSaucerVid, quantity: qty, properties: sProps });
      }
      if (addWord) {
        var aProps = {};
        aProps[CFG.wordProperty || 'Mot'] = wordValue.trim();
        aProps[SAU.setProperty || '_nn_set'] = setToken; /* lie le supplement au mug (verrou enfant cote panier) */
        items.push({ id: CFG.addonVariantId, quantity: qty, properties: aProps });
      }
      /* Shopify affiche les lignes d'un meme add du plus recent au plus ancien : on inverse pour montrer le mug en premier */
      items.reverse();
      addItemsLikeImpact(form, vid, items);
    }, true);
  }

  /* reproduit le flux d'ajout natif d'Impact (ouvre le drawer + events) au lieu de rediriger */
  function addItemsLikeImpact(form, vid, items) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var settings = (window.themeVariables && window.themeVariables.settings) || {};
    var btns = form ? [].slice.call(form.querySelectorAll('[type="submit"]')) : [];
    btns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
    /* 1. collecter les sections que le drawer/notification doivent re-rendre */
    var sections = ['variant-added'];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
    /* 2. ajout multi-ligne avec rendu des sections (comme le product-form natif) */
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items, sections: sections.join(','), sections_url: root + 'variants/' + vid })
    }).then(function (res) {
      return res.json().then(function (json) { return { ok: res.ok, json: json }; });
    }).then(function (r) {
      btns.forEach(function (b) { b.removeAttribute('aria-busy'); });
      if (!r.ok) {
        if (form) form.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error: r.json && r.json.description } }));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        return;
      }
      /* cartType "page" (ou page panier) : la redirection est le comportement natif */
      if (settings.cartType === 'page' || settings.pageType === 'cart') { window.location.href = root + 'cart'; return; }
      /* 3. recuperer le panier complet + greffer les sections rendues, puis dispatcher les events Impact */
      fetch(root + 'cart.js').then(function (c) { return c.json(); }).then(function (cart) {
        cart.sections = r.json.sections;
        var added = Object.prototype.hasOwnProperty.call(r.json, 'items') ? r.json.items : [r.json];
        if (form) form.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: added, cart: cart } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
      });
    }).catch(function () {
      btns.forEach(function (b) { b.removeAttribute('aria-busy'); });
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    });
  }

  /* ---- variant:change : prix + apercu + reconciliation couleur ---- */
  document.addEventListener('variant:change', function (ev) {
    var v = ev && ev.detail && ev.detail.variant;
    if (!v) return;
    var opts = v.options || [v.option1, v.option2, v.option3];
    var fpos = (CFG.formatPosition || 1) - 1;
    var spos = (CFG.sizePosition || 3) - 1;
    var cpos = (CFG.colorPosition || 2) - 1;
    if (typeof v.price === 'number') { currentCents = v.price; renderPrice(); }
    var fmt = fmtKey(opts[fpos]), sz = sizeKey(opts[spos]);
    applyMedia(fmt, sz);
    updateOptionThumbs(fmt, sz);
    var cn = parseColorN(opts[cpos]);
    if (cn && cn !== currentColorN) applyColor(cn);
    if (saucerEnabled()) { resolveSaucer(sz); renderSaucer(); }
  }, { passive: true });

  function parseColorN(label) {
    var m = String(label || '').match(/\d{1,2}/);
    if (!m) return null;
    var n = parseInt(m[0], 10);
    return (n >= 1 && n <= 20) ? n : null;
  }

  /* ---- apres un rerender partiel d'Impact : re-applique prix + proprietes ---- */
  function watchRerender() {
    var rer = document.querySelector('product-rerender');
    if (!rer || !window.MutationObserver) return;
    var mo = new MutationObserver(function () { renderPrice(); applyProps(); });
    mo.observe(rer, { childList: true, subtree: true });
  }

  /* ---- amorcage ---- */
  function boot() {
    wireSwatches();
    wireToggles();
    wireAccordion();
    wireWord();
    wireSaucer();
    wireAddon();
    watchRerender();
    if (currentColorN) applyColor(currentColorN);
    applyMedia(CFG.initialFormat || 'mug', CFG.initialSize || 'M');
    updateOptionThumbs(CFG.initialFormat || 'mug', CFG.initialSize || 'M');
    wireLightbox();
    if (saucerEnabled()) { resolveSaucer(CFG.initialSize || 'M'); renderSaucer(); }
    applyProps();
    renderPrice();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
